<template>
  <a-modal
      :title="title"
      :visible="visible"
      :width="1000"
      @ok="handleSubmit"
      @cancel="handleCancel">
    <a-form :form="form">
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="登陆账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入用户账号" v-decorator.trim="[ 'username', validatorRules.username]"
                     :disabled="usernameDisable"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入用户名" v-decorator.trim="[ 'name', validatorRules.name]"
                     :disabled="usernameDisable"/>
          </a-form-item>
        </a-col>
      </a-row>
      <template v-if="!model.id">
        <a-row class="form-row">
          <a-col :span="12">
            <a-form-item label="登录密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input type="password" placeholder="请输入登陆密码" autocomplete="off"
                       v-decorator.trim="['password', validatorRules.password]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="确认密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input type="password" placeholder="请重新输入登陆密码" autocomplete="off"
                       v-decorator.trim="[ 'confirmpassword', validatorRules.confirmpassword]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入邮箱" v-decorator.trim="[ 'email', validatorRules.email]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="角色分配" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
                mode="multiple"
                placeholder="选择角色分配"
                :filter-option="false"
                :token-separators="[',']"
                v-decorator.trim="['roles', validatorRules.roles]">
              <a-select-option v-for="item in roleList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="欧美填表" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number :min="0" placeholder="请输入有效次" style="width: 100%"
                            v-decorator.trim="[ 'silverNum', validatorRules.silverNum]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="东南亚填表" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number :min="0" placeholder="请输入有效次" style="width: 100%"
                            v-decorator.trim="[ 'bronzeNum', validatorRules.bronzeNum]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="签证导出" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number :min="0" placeholder="请输入签证导出有效次" style="width: 100%"
                            v-decorator.trim="[ 'ironNum', validatorRules.ironNum]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="泰国账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="送签账号" v-decorator.trim="[ 'thaAccount', validatorRules.thaAccount]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="泰国密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="送签密码" v-decorator.trim="[ 'thaPwd', validatorRules.thaPwd]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="澳大利亚账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="送签账号" v-decorator.trim="[ 'ausAccount', validatorRules.ausAccount]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="澳大利亚密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="送签密码" v-decorator.trim="[ 'ausPwd', validatorRules.ausPwd]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :span="12">
          <a-form-item label="启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-switch v-decorator="['enabled', validatorRules.enabled]"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="备注" v-decorator.trim="[ 'remark', validatorRules.remark]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import pick from "lodash/pick";
import moment from 'moment'
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "UserCreateModal",
  mixins: [HttpMixins],
  data() {
    return {
      title: '',
      visible: false,
      usernameDisable: true,

      model: {},
      form: this.$form.createForm(this),
      postList: [],
      roleList: [],
      dptList: [],
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
      },
      validatorRules: {
        username: {rules: [{required: true, message: '请输入用户账号!'}]},
        name: {rules: [{required: true, message: '请输入用户名!'}]},
        email: {rules: [{type: 'email', message: '格式不正确!'}, {required: true, message: '请输入邮箱!!'}]},
        password: {rules: [{required: true, message: '请输入登录密码!'}]},
        confirmpassword: {
          rules: [{
            required: true, message: '请重新输入登陆密码!',
          }, {
            validator: this.compareToFirstPassword,
          }],
        },
        roles: {rules: [{required: true, message: '请选择角色!'}]},
        userIdentity: {},
        thaAccount: {rules: [{message: '必填项!'}]},
        thaPwd: {rules: [{message: '必填项!'}]},
        ausAccount: {rules: [{message: '必填项!'}]},
        ausPwd: {rules: [{message: '必填项!'}]},
        bronzeNum: {rules: [{required: true, message: '必填项!'}]},
        silverNum: {rules: [{required: true, message: '必填项!'}]},
        ironNum: {rules: [{required: true, message: '必填项!'}]},
        enabled: {valuePropName: 'checked'},
        remark: {},
      },
      url: {
        add: window._CONFIG['domainURL'] + "/user",
        edit: window._CONFIG['domainURL'] + "/user",
        roleListAll: window._CONFIG['domainURL'] + "/role/listAll",
      }
    }
  },

  mounted() {
    this.initRoleList();
  },
  methods: {
    moment,
    initRoleList() {
      let that = this;
      that.$axios.get(that.url.roleListAll, {headers: that.headers})
          .then((body) => {
            that.roleList = body.data;
          });
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样！');
      } else {
        callback()
      }
    },

    add() {
      this.visible = true;
      this.title = '新增';
      this.model = {};
      this.usernameDisable = false;
      this.form.resetFields();
    },

    edit(record) {
      let that = this;
      this.add();
      that.title = '编辑';
      this.usernameDisable = true;
      that.model = Object.assign({}, record);
      if (that.model.roles) {
        that.model.roles = that.model.roles.split(',');
      }
      that.$nextTick(() => {
        that.form.setFieldsValue(pick(that.model, 'username', 'name', 'post', 'roles', 'sex', 'email', 'bronzeNum', 'silverNum', 'ironNum', 'thaAccount', 'thaPwd', 'ausAccount', 'ausPwd', 'telephone', 'dpt', 'enabled', 'remark'));
        that.form.setFieldsValue({birthday: that.model.birthday ? moment(that.model.birthday) : null})
      });
    },

    handleSubmit() {
      const that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let param = Object.assign({}, values);
          param.roles = param.roles.toString();
          if (param.birthday) {
            param.birthday = param.birthday.format('YYYY-MM-DD');
          }
          if (that.title === '编辑') {
            param.id = that.model.id;
            param.accountNonExpired = that.model.accountNonExpired;
            param.accountNonLocked = that.model.accountNonLocked;
            param.credentialsNonExpired = that.model.credentialsNonExpired;
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success(response.msg);
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.put(that.url.edit, param, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
          if (that.title === '新增') {
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success(response.msg);
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.post(that.url.add, param, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
        }
      })
    },
    handleCancel() {
      this.visible = false;
    },

  }
}
</script>

<style scoped>

</style>
